/*
 * @Author: dinglizu
 * @Date: 2022-04-22 20:34:54
 * @LastEditTime: 2022-10-06 11:42:01
 * @LastEditors: dinglizu
 * @Description: 
 */
export const token = (state, token) => {
  if (token) {
    state.token = token;
  } else {
    state.token = null;
  }
}
export const userInfo = (state, userInfo) => {
  if (userInfo) {
    state.userInfo = Object.assign(state.userInfo || {}, userInfo);
  }else{
   state.userInfo = {}
  }
}

export const toeflModel = (state, toeflModel) => {
  if (toeflModel) {
    state.toeflModel.paperType = toeflModel.paperType;
    state.toeflModel.outType = toeflModel.outType;
    state.toeflModel.tabIndex = toeflModel.tabIndex;
  } else {
    state.toeflModel = null;
  }
}

export const testReport = (state, testReport) => {
  if (testReport) {
    state.testReport = testReport;
  } else {
    state.testReport = null;
  }
}
export const browse = (state, browse) => {
  if (browse) {
    state.browse = browse;
  } else {
    state.browse = null;
  }
}
export const practice = (state, practice) => {
  if (practice) {
    state.practice = practice;
  } else {
    state.practice = null;
  }
}
export const card = (state, card) => {
  if (card) {
    state.card = card;
  } else {
    state.card = null;
  }
}
export const globalConfig = (state, globalConfig) => {
  if (globalConfig) {
    state.globalConfig = state.globalConfig || {}
    Object.assign(state.globalConfig, globalConfig);
  } else {
    state.globalConfig = null;
  }
}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js